import { render } from "./WhyUsSection.vue?vue&type=template&id=fdbf54b2"
import script from "./WhyUsSection.vue?vue&type=script&lang=js"
export * from "./WhyUsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__